export default __webpack_public_path__ + "static/media/appstore.c99b561e.svg";